import React from 'react'
import Image from 'components/image/image'
import './block-number-quote.sass'


const getImage = (img) => (
  <div>
    <Image image_url={`content/${img}`}
           className="img-fluid"
           alt={img}/>
  </div>
)

const getMarkDown = (md) => (
  <div
    dangerouslySetInnerHTML={{ __html: md }} />
)

const getQuoteMarkdown = (quote) => {
  return (
    <blockquote className="BlockNumberQuote__quote">
      <div className="BlockNumberQuote__quote__inner k-background-box"
            dangerouslySetInnerHTML={{ __html: quote }} />
    </blockquote>
  )
}

const getContent = (contents) => {
  return contents.map((content, i) => {
    return (
      <React.Fragment key={i}>
        {
          content.indexOf('content/') > -1
            ? getImage(content.split('content/').pop(1))
            : getMarkDown(content)
        }
      </React.Fragment>
    )
  })
}

const getQuote = (contents) => {
  return contents.map((content, i) => {
    return (
      <React.Fragment key={i}>
        {
          content.indexOf('content/') > -1
            ? getImage(content.split('content/').pop(1))
            : getQuoteMarkdown(content)
        }
      </React.Fragment>
    )
  })
}

const BlockNumberQuote = ({ data }) => {
  return (
    <section className={`BlockNumberQuote ${data.classes ? data.classes : ''}`}>
      <div className="container-fluid">
        <div className="BlockNumberQuote__title d-flex align-items-center mb-3">
          <span className="BlockNumberQuote__number mr-3">{data.number}</span>
          <h4 className="mb-0">{data.title}</h4>
        </div>
        { data.content ?
            getContent(data.content) :
            null
        }
        { data.quote ?
            getQuote(data.quote) :
            null
        }
      </div>
    </section>
  )
}

export default BlockNumberQuote
